<template>

    <div>

        <!-- Top navbar` -->
        <modal-header :title="'All topics'" :right="'close'">

            <template v-slot:leftComponent>
                <span @click="$emit('changeContent', {page: 'list'})" class="asset-icon asset-icon--modal-header icon-green-back"></span>
            </template>

        </modal-header>

        <!-- Loading animation -->
        <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

        <!-- Main content -->
        <main-div v-if="!initLoad">
            <div class="faq-article">
                <h1 class="faq-article--title">{{ faq.title }}</h1>
                <div class="faq-article--content" v-html="textFormatted"></div>
            </div>
        </main-div>

    </div>

</template>

<script>
    export default {

        props: {
            id: {
                default: null,
            },
        },

        data: function () {
            return {
                initLoad: true,
                faq: {
                    title: '',
                    answer: '',
                },
            }
        },

        computed: {
            textFormatted: function() {
                return this.faq.answer.replace(/(?:\r\n|\r|\n)/g, '<br>')
            }
        },

        created: function() {
            axios
                .get("faq/" + this.id)
                .then(response => {
                    this.initLoad = false
                    this.faq = response.data['faq']

                    let source = this.$route.fullPath
                    if(this.$root.modalStack.length) {
                        source = _.last(this.$root.modalStack)[0]
                    }
                    this.$root.triggerPageGEvent(this.$root.currentModal, { id: this.id, question: this.faq.title, source: source })
                })
        }
    }
</script>
